import React from "react";
import "./Header.css";

const Header = ({ logo, headerTitle }) => {
  return (
    <div className="header">
      <nav className="navbar navbar-light navbar-bg-color border navbar-border-color">
        <a className="navbar-brand">
          <img
            src={logo}
            width="69"
            height="57"
            className="d-inline-block align-top"
            alt=""
          />
          <p className="navbar-text">{headerTitle}</p>
        </a>
      </nav>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// /src/Header/Header.js